import React from 'react';
import {Icon, FormField, Tag, Settings, EditableTag} from 'components';
import {generate, over, uniq, stopPropagation, useField, useBuffer, useSuggestionPopup, useNamedSelector} from 'helpers';
import {store} from 'store';
import css from './tags.module.scss';

export function Tags(props) {
  const { getByIds, getByName } = useNamedSelector('tags.tags');
  const [ { value }, , { setValue } ] = useField(props);
  const selected = getByIds(value);

  const add = ({ id }) => setValue(uniq([...selected.map(tag => tag.id), id]).join(','));
  const remove = ({ id }) => setValue(selected.filter(item => item.id != id).map(tag => tag.id).join(','));

  const [input, {focused}] = useBuffer({
    value: '',
    onChange: buffer => {
      if (buffer.value.trim()) {
        const tag = getByName(buffer.value) || { name: buffer.value, id: generate(), new: true };
        add(tag);
        store.dispatch({ type: 'TAGS_NEW', ...tag });
        buffer.update({ value: '' });
        requestAnimationFrame(() => control.ref.current.focus());
      }
    }
  });

  const [popup, control] = useSuggestionPopup(Settings.CurrentTags, {
    ...props,
    add,
    remove,
    value: input.value,
    deps: [input.value, value, getByIds],
    selected,
    className: 'adjacent'
  });

  return (
    <FormField Wrapper="div" {...popup} onClick={() => control.ref.current.focus()}>
      <FormField.Label>Tags</FormField.Label>
      <div className={css.tags}>
        {selected.map(tag =>
          <Tag key={tag.id}>
            { tag.name }
            <Icon name="close" className="secondary" onClick={over(() => remove(tag), stopPropagation)} />
          </Tag>
        )}
        <EditableTag value={input.value} placeholder={focused ? 'Enter tag..' : '+ add'}>
          <input
            {...input}
            {...control}
            onChange={over(input.onChange, control?.onChange)}
          />
        </EditableTag>
      </div>
    </FormField>
  );
}
